define('global-settings', function(require) {
    'use strict';

    return {
        menuBarHeightPixels: '100'
    };
});